// extracted by mini-css-extract-plugin
export var container = "_j5-0";
export var dotAnimation = "_j5-2";
export var dotsLoading = "_j5-1";